import { ConditionType } from '@validators/types'

export const coupons: ConditionType = {
	name: {
		rules: ['require'],
		message: {
			require: 'Name is a required field.',
		},
	},
	email: {
		rules: ['require'],
		message: {
			require: 'Email is a required field.',
		},
	},
	discountUsd: {
		rules: ['require'],
		message: {
			require: 'Discount is a required field.',
		},
	},
	quantity: {
		rules: ['require'],
		message: {
			require: 'Quantity is a required field.',
		},
	},
	expiredAt: {
		rules: ['require'],
		message: {
			require: 'ExpiredAt is a required field.',
		},
	},
}
